import { CompoundSearchCriterion } from '@neptune/recent-searches-domain';

import { useRecentSearches } from './use-recent-searches';

export function useRecentCompoundQueries({ namespace }: { namespace: string }) {
  return useRecentSearches<CompoundSearchCriterion[]>({
    namespace,
    key: 'recentCompoundQueries',
    getInitialState: (lsState, currentKey) =>
      lsState?.recentCompoundQueries?.[namespace]?.[currentKey],
  });
}
